@if (isVisible() && user()) {
  <div class="dialog-overlay" (click)="closeDialog()">
    <div class="role-dialog" (click)="$event.stopPropagation()">

      <div class="role-dialog-header">
        <div class="role-dialog-user">
          <div class="user-avatar large" [class.avatar-img-wrap]="getProfileImage()">
            @if (getProfileImage()) {
              <img [src]="getProfileImage()" alt="Profile" />
            }
            @if (!getProfileImage()) {
              <span>
                {{ getInitials(user()?.firstName, user()?.lastName) }}
              </span>
            }
          </div>
          <div>
            <h4>{{ getDisplayName() | titlecase }}</h4>
            <p>{{ user()?.email || 'N/A' }}</p>
          </div>
        </div>
        <button class="btn-close" (click)="closeDialog()">
          <i class="pi pi-times"></i>
        </button>
      </div>

      <div class="role-dialog-body">
        <p class="role-dialog-hint">Select a role to assign to this user:</p>

        <div class="role-options">
          <div class="role-option" [class.role-option-selected]="pendingRole() === 'user'" (click)="selectRole('user')">
            <div class="role-option-icon role-user">
              <i class="pi pi-user"></i>
            </div>
            <div class="role-option-info">
              <span class="role-option-name">User</span>
              <span class="role-option-desc">Standard access. Can browse and interact with the app.</span>
            </div>
            @if (pendingRole() === 'user') {
              <i class="pi pi-check-circle role-check"></i>
            }
          </div>

          <div class="role-option" [class.role-option-selected]="pendingRole() === 'admin'" (click)="selectRole('admin')">
            <div class="role-option-icon role-admin">
              <i class="pi pi-shield"></i>
            </div>
            <div class="role-option-info">
              <span class="role-option-name">Admin</span>
              <span class="role-option-desc">Manage users, content, and moderate the platform.</span>
            </div>
            @if (pendingRole() === 'admin') {
              <i class="pi pi-check-circle role-check"></i>
            }
          </div>

          <div class="role-option" [class.role-option-selected]="pendingRole() === 'super_admin'"
            (click)="selectRole('super_admin')">
            <div class="role-option-icon role-superadmin">
              <i class="pi pi-star"></i>
            </div>
            <div class="role-option-info">
              <span class="role-option-name">Superadmin</span>
              <span class="role-option-desc">Full access. Manage roles, settings, and all platform data.</span>
            </div>
            @if (pendingRole() === 'super_admin') {
              <i class="pi pi-check-circle role-check"></i>
            }
          </div>
        </div>
      </div>

      <div class="role-dialog-footer">
        <button class="btn-cancel" (click)="closeDialog()">Cancel</button>
        <button class="btn-confirm" (click)="confirmRoleChange()" [disabled]="pendingRole() === user()?.role">
          Confirm Change
        </button>
      </div>

    </div>
  </div>
}